/**
 * Return `size` items from `items` starting at `start`, wrapping around to the
 * beginning when the end is reached (so the last window, if shorter than `size`,
 * is topped up from the front). When there are `size` items or fewer, the whole
 * list is returned unchanged. Ported in spirit from the Deploy wizard's
 * `getCircularSlice`.
 */
export function circularSlice<T>(items: T[], size: number, start: number): T[] {
  const n = items.length;
  if (n === 0 || size <= 0) return [];
  if (n <= size) return items;
  const out: T[] = [];
  for (let i = 0; i < size; i += 1) out.push(items[(start + i) % n]);
  return out;
}

/** Next window start after advancing by `size` (wraps). Returns 0 when there is
 *  nothing to paginate (≤ `size` items). */
export function nextSliceStart(length: number, size: number, start: number): number {
  if (length <= size) return 0;
  return (start + size) % length;
}